var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"py-3"},[_c('div',{staticClass:"container"},[_c('HMLogo',{staticClass:"logo"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }